import { Component, computed, Input } from '@angular/core';
import { DatePipe, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ChronoInput } from '../../../shared/models/chrono.model';
import { CrView } from '../../../shared/models/v2/cr.model';
import { UnplannedOt } from '../../../shared/models/v2/ot.model';

@Component({
  selector: 'cr-brouillon-list-item',
  templateUrl: 'cr-brouillon-list-item.component.html',
  standalone: true,
  styleUrls: ['./cr-brouillon-list-item.component.scss'],
  imports: [NgIf, DatePipe, TranslateModule],
})
export class CrBrouillonListItemComponent {
  @Input() brouillon: CrView | ChronoInput | UnplannedOt;

  constructor() {}

  getTitle = computed(() => {
    if (this.brouillon.type === 'cr-view') {
      if (this.brouillon.ot.libelle_intervention) {
        return this.brouillon.ot.libelle_intervention;
      }
      if (this.brouillon.ot.description) {
        return this.brouillon.ot.description;
      }
    }
    if (this.brouillon.type === 'unplanned-ot') {
      return this.brouillon.description;
    }
    return '';
  });

  getDate = computed(() => {
    if (this.brouillon.type === 'chrono-input') {
      return this.brouillon.date_modification_intervenant;
    } else if (this.brouillon.type === 'unplanned-ot') {
      return this.brouillon.cr.date_modification_intervenant;
    }
    return '';
  });
}
